module.exports = __webpack_public_path__ + "static/Landing_Top_logo-f9e12e5fae5abb4b81e15f04160a1865.svg";